<template >
  <div>
    <b-card-code :title="data.doc_name">
      <button
        v-if="!downloading.includes(data.doc_id)"
        type="button"
        @click="download(data)"
        class="btn ml-auto btn-primary float-right"
      >
        Download
      </button>
      <button
        v-else
        type="button"
        @click="download(data)"
        class="btn ml-auto btn-secondary float-right"
      >
        Please wait..
      </button>

      <div>
        <h5 class="text-primary">Project</h5>
        <p>{{ data.project_profile.project_name }}</p>
      </div>
      <div>
        <h5 class="text-primary">Added By</h5>
        <p>{{ data.added_by }}</p>
      </div>
      <div>
        <h5 class="text-primary">Added At</h5>
        <p>{{ data.created_at | formatdate }}</p>
      </div>
      <div>
        <h5 class="text-primary">Doc Type</h5>
        <p>{{ data.document_type | serviceTypeFilter }}</p>
      </div>
    </b-card-code>
    <b-card-code title="Versions">
      <b-table
        responsive
        id="versionTable"
        :fields="version_fields"
        :items="version_items"
        :per-page="version_perPage"
        v_currentPage
      >
        <template #cell(index)="data">
          {{ data.index + 1 + perPage * (v_currentPage - 1) }}
        </template>
        <template #cell(doc_name)="data">
          <router-link :to="'/document/view/' + data.item.doc_id"
            >{{ data.item.document_type }} /
            {{ data.item.doc_name }}</router-link
          >
        </template>
        <template #cell(owners)="data">
          <b-badge
            class="mb-1 mr-1"
            variant="primary"
            v-for="owner in data.item.owners"
            :key="owner.o_id"
            >{{ owner.profile.first_name }}
            {{ owner.profile.last_name }}</b-badge
          >
        </template>
        <template #cell(created_at)="data">
          {{ data.item.created_at | formatdate }}
        </template>
        <template #cell(actions)="data">
          <button
            @click="download(data.item)"
            v-if="!downloading.includes(data.item.doc_id)"
            type="button"
            class="btn btn-primary btn-sm mr-1"
            style="position: relative"
            :ref="`download_${data.item.doc_id}`"
          >
            Download
          </button>
          <button
            v-else
            type="button"
            class="btn btn-secondary btn-sm mr-1"
            style="position: relative"
          >
            Download
          </button>
        </template>
      </b-table>
    <b-pagination
      v-model="v_currentPage"
      :total-rows="v_rows"
      :per-page="version_perPage"
      :align="pagination_pos"
      aria-controls="versionTable"
    />
    </b-card-code>
    <b-card-code title="Logs">
      <div class="d-flex justify-content-center mb-1" v-if="loading">
        <b-spinner class="float-right" label="Floated Right" />
      </div>
      <b-table
        responsive
        id="cvdTable"
        :fields="computedFields"
        :items="items"
        :per-page="perPage"
        v-if="!loading"
      >
        <template #cell(index)="data">
          {{ data.index + 1 + perPage * (currentPage - 1) }}
        </template>
        <template #cell(activity_time)="data">
          <span>{{ data.item.activity_time | formatdate }}</span>
        </template>
      </b-table>

      <b-pagination-nav
        v-model="currentPage"
        :numberOfPages="total"
        :link-gen="linkGen"
        :total-rows="rows"
        :per-page="perPage"
        :align="pagination_pos"
        aria-controls="cvdTable"
        use-router
        v-if="total>0"
      />
    </b-card-code>
  </div>
</template>
<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { BTable } from "bootstrap-vue";
import {
  BPagination,
  BPaginationNav,
  BButton,
  BBadge,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BForm,
  BFormInput,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";
import moment from "moment";
export default {
  components: {
    BCardCode,
    BTable,
    BPagination,
    BPaginationNav,
    BButton,
    BBadge,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BForm,
    BFormInput,
    BFormSelect,
    BSpinner,
  },
  data: function () {
    return {
      id: this.$route.params.id,
      data: {},
      is_downloading: false,
      pagination_pos: "center",
      // Call orgaization API and return in this format
      items: [],
      currentPage: 1,
      perPage: 10,
      rows: 0,
      total: 1,
      loading: false,
      is_staff: this.$store.state.app.user.is_staff,
      fields: [
        { key: "index", label: "#" },
        { key: "log_message", labperPage: 10,el: "Log Message" },
        { key: "activity_on", label: "Activity on", requiresAdmin: true },
        { key: "ref_id", label: "Ref ID", requiresAdmin: true },
        { key: "activity_time", label: "Activity Time" },
      ],
      version_items: [],
      version_perPage: 5,
      v_currentPage: 1,
      v_rows: 0,
      v_total: 1,
      version_fields: [
        { key: "index", label: "#" },
        { key: "doc_name", label: "Document" },
        { key: "added_by", label: "Added By" },
        { key: "version_label", label: "Version" },
        { key: "version_description", label: "What's changed" },
        { key: "created_at", label: "Uploaded At" },
        { key: "actions", label: "Actions" },
      ],
      downloading: []
    };
  },

  created: function () {
    this.load();
    this.load_logs();
  },
  computed: {
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (!this.is_staff)
        return this.fields.filter((field) => !field.requiresAdmin);
      // If the user IS an admin, return all fields.
      else return this.fields;
    },
  },
  filters: {
    formatdate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY hh:mm A");
      }
    },
    serviceTypeFilter: function (value) {
      if (value) {
        if(value == "Proxy for Old projects")
          return "Not Specified"
        //if(value.includes("Offshore")){
        else{
          const service_name_splitted = value.split("-");
          let service_name = service_name_splitted[0];
          return service_name;
        }
      }
    },

  },
  watch: {
    currentPage: function (newVal, oldVal) {
      this.load_logs(false);
    },
    '$route.params.id':function (newVal, oldVal) {
      this.load();
    },
  },
  methods: {
    linkGen: function (pageNum) {
      return this.$router.currentRoute.path + "?page=" + pageNum;
    },
    load: function () {
      if (this.$route.query.page) this.currentPage = this.$route.query.page;
      const o_options = {
        method: "GET",
        headers: { "content-type": "application/json" },
        url:
          process.env.VUE_APP_BASEURL +
          "client/project/docs/" +
          this.$route.params.id, //+'/vuln-details/',
      };
      var self = this;
      this.$http(o_options).then((res) => {
        self.data = res.data;
        self.version_items = res.data.versions
        self.v_rows = res.data.versions.length;
        self.v_total = Math.ceil(self.v_rows/ self.version_perPage);
        //alert(self.v_total)
      });
    },
    load_logs: function (reset = true) {
      this.is_search_on = false;
      this.loading = true;
      this.filter = [];
      if (reset) this.currentPage = 1;
      let url =
        process.env.VUE_APP_BASEURL +
        "logs/v1/logs/doc-logs?query=true" +
        "&page=" +
        this.currentPage;
      url = url + "&doc_id=" + this.$route.params.id;

      if (this.user != null) {
        this.filter.push({ user: this.user });
        url = url + "&user_id=" + this.user;
      }

      if (this.filter.length) this.is_search_on = true;
      const options = {
        method: "GET",
        headers: { "content-type": "application/json" },
        url: url,
      };
      this.$http(options).then((res) => {
        this.items = res.data.results;
        this.rows = res.data.length;
        this.total = Math.ceil(res.data.count / this.perPage);
        // alert(this.total)
        this.loading = false;
      });
    },
    download(item) {
      // extract extension and make filename
      let filepath = JSON.parse(item.doc_url);
      let ext = filepath.key.split("/")[1].split(".")[1];
     // this.is_downloading = true;
      this.downloading.push(item.doc_id);
      console.log("Download in progress", this.downloading);
      // this.loading = true;
      const options = {
        method: "GET",
        url:
          process.env.VUE_APP_BASEURL +
          "client/project/docs/" +
          item.doc_id +
          "/download/",
        responseType: "blob",
      };
      var self = this;
      this.$http(options)
        .then((res) => {
          // this.loading = false;
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.doc_name + "." + ext); //or any other extension
          document.body.appendChild(link);
          link.click();
          //self.is_downloading = false;
          self.downloading.pop(item.doc_id);
          self.load_logs();
        })
        .catch(function (error) {
          alert("Error, please try agin");
          console.log(error);
          //self.is_downloading = false;
          self.downloading.pop(item.doc_id);
        });
    },
  },
};
</script>